// App.js
import { Routes, Route } from "react-router-dom";



import Home from "./compnent/home/Home";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import MenuOne from "./compnent/home/MenuOne";
import MenuTwo from "./compnent/home/MenuTwo";
import MenuThree from "./compnent/home/MenuThree";


const App = () => {



  useEffect(() => {
    AOS.init({
      duration: 1500,        // animation duration
      once: true,           // ✅ animate only once (IMPORTANT)
      easing: "ease-in-out",
      offset: 0,          // trigger before element comes fully into view
    });
  }, []);


  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/menu-one" element={<MenuOne />} />
        <Route path="/menu-two" element={<MenuTwo />} />
        <Route path="/menu-three" element={<MenuThree />} />
      </Routes>
    </>
  );
};

export default App;
